import NavBar from "components/NavBar/NavBar";
import "styles/root/root.css";
import "styles/globals.css";

/** Mise en page connectée : barre de navigation + zone de contenu des pages. */
function AppShell({ children }) {
  return (
    <>
      <div className="root-content-page">
        <div className="prototype-nav">
          <NavBar />
        </div>
        <div className="content-content">{children}</div>
      </div>
    </>
  );
}

export default AppShell;
